import { render, staticRenderFns } from "./QuestRecap.vue?vue&type=template&id=a4dad836&scoped=true&"
import script from "./QuestRecap.ts?vue&type=script&lang=ts&"
export * from "./QuestRecap.ts?vue&type=script&lang=ts&"
import style0 from "./QuestRecap.scss?vue&type=style&index=0&id=a4dad836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dad836",
  null
  
)

export default component.exports